module.exports = __webpack_public_path__ + "img/JobTotalRecieved_rej.2d5f4fd7.svg";